var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"role":"presentation","fill":"none"}},[_c('path',{attrs:{"d":"M5 12H19","stroke":"#242424","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }